import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

function PrivateRoute({ component: Component, user, isLoadingUser, ...rest }) {
  return (
    !isLoadingUser && (
      <Route
        {...rest}
        render={props =>
          user && !user.expired ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                from: props.location
              }}
            />
          )
        }
      />
    )
  );
}

function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    isLoadingUser: state.oidc.isLoadingUser
  };
}

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  user: PropTypes.object,
  isLoadingUser: PropTypes.bool,
  location: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(PrivateRoute);
